import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { ChannelOutput2 } from "~@/graphql/codegen/generated";

export enum ChannelMethod {
  Update = "update",
  Reconnect = "reconnect",
  Create = "create",
  Delete = "delete",
}

type ChannelSettingsState = {
  selectedChannel?: ChannelOutput2;
  method: Exclude<ChannelMethod, ChannelMethod.Delete>;
  modalMethod:
    | Exclude<
        ChannelMethod,
        ChannelMethod.Update | ChannelMethod.Create | ChannelMethod.Reconnect
      >
    | undefined;
};

const initialState: ChannelSettingsState = {
  selectedChannel: undefined,
  method: ChannelMethod.Update,
  modalMethod: undefined,
};

const channelsSlice = createSlice({
  name: "channels",
  initialState,
  reducers: {
    setSelectedChannel(
      state,
      action: PayloadAction<ChannelOutput2 | undefined>
    ) {
      state.selectedChannel = action.payload;
    },
    setMethod(
      state,
      action: PayloadAction<Exclude<ChannelMethod, ChannelMethod.Delete>>
    ) {
      state.method = action.payload;
    },
    setModalMethod(
      state,
      action: PayloadAction<
        | Exclude<
            ChannelMethod,
            | ChannelMethod.Update
            | ChannelMethod.Create
            | ChannelMethod.Reconnect
          >
        | undefined
      >
    ) {
      state.modalMethod = action.payload;
    },
    clearSelectedChannel(state) {
      state.selectedChannel = undefined;
    },
    clearModalMethod(state) {
      state.modalMethod = undefined;
    },
  },
});

export const {
  setSelectedChannel,
  setMethod,
  setModalMethod,
  clearSelectedChannel,
  clearModalMethod,
} = channelsSlice.actions;

export default channelsSlice.reducer;
